import {FormBuilder, FormGroup} from "@angular/forms";

export class FileTypes {
  id: number = -1;
  color: string = '';
  icon: string = '';
  description: string = '';
  type: AcceptedFileType = null;
  allowedExtensions: string[] = [];
}

export class FileDecisions {
  makeOcrForTables: {
    type: string;
    value: boolean;
  }
  saveTablesAsImages: {
    type: string;
    value: boolean;
  }
  makeOcrForImages: {
    type: string;
    value: boolean;
  }
  includeImportantMoments: {
    type: string;
    value: boolean;
  }
  hasTranscript: {
    type: string;
    value: boolean;
  };
  lengthLow: {
    type: string;
    value: number;
  }
  lengthHigh: {
    type: string;
    value: number;
  }
  stopWordsLow: {
    type: string;
    value: number;
  }
  stopWordsHigh: {
    type: string;
    value: number;
  }
  mode: {
    type: string;
    value: ExtractionMode;
  }
  excludeLines: {
    type: string;
    value: boolean;
  }
  includeImages: {
    type: string;
    value: boolean;
  }
  includeFormatting: {
    type: string;
    value: boolean;
  }
  language: {
    type: string;
    value: Languages;
  }

  constructor() {
    // Varsayılan değerleri ayarla
    this.makeOcrForTables = {
      type: "pdf",
      value: false
    };
    this.saveTablesAsImages = {
      type: "pdf",
      value: false
    };
    this.makeOcrForImages = {
      type: "pdf",
      value: false
    };
    this.includeImportantMoments = {
      type: "video",
      value: false
    };
    this.hasTranscript = {
      type: "video",
      value: false
    };
    this.lengthLow = {
      type: "scraper",
      value: 10
    };
    this.lengthHigh = {
      type: "scraper",
      value: 20
    };
    this.stopWordsLow = {
      type: "scraper",
      value: 0.0
    };
    this.stopWordsHigh = {
      type: "scraper",
      value: 0.2
    };
    this.mode = {
      type: "scraper",
      value: ExtractionMode.AUTO
    };
    this.excludeLines = {
      type: "scraper",
      value: false
    };
    this.includeImages = {
      type: "scraper",
      value: false
    };
    this.includeFormatting = {
      type: "scraper",
      value: false
    };
    this.language = {
      type: "scraper",
      value: Languages.TR
    };
  }

  bind(obj) {
    this.makeOcrForTables =  {
      type: "pdf",
      value: obj.makeOcrForTables ?? false
    };
    this.saveTablesAsImages = {
      type: "pdf",
      value: obj.saveTablesAsImages ?? false
    };
    this.makeOcrForImages = {
      type: "pdf",
      value: obj.makeOcrForImages ?? false
    };
    this.includeImportantMoments = {
      type: "video",
      value: obj.includeImportantMoments ?? false
    };
    this.hasTranscript = {
      type: "video",
      value: obj.hasTranscript ?? false
    };
    this.lengthLow = {
      type: "scraper",
      value: obj.lengthLow ?? 10
    };
    this.lengthHigh = {
      type: "scraper",
      value: obj.lengthHigh ?? 20
    };
    this.stopWordsLow = {
      type: "scraper",
      value: obj.stopWordsLow ?? 0.0
    };
    this.stopWordsHigh = {
      type: "scraper",
      value: obj.stopWordsHigh ?? 0.2
    };
    this.mode = {
      type: "scraper",
      value: obj.mode ?? ExtractionMode.AUTO
    };
    this.excludeLines = {
      type: "scraper",
      value: obj.excludeLines ?? false
    };
    this.includeImages = {
      type: "scraper",
      value: obj.includeImages ?? false
    };
    this.includeFormatting = {
      type: "scraper",
      value: obj.includeFormatting ?? false
    };
    this.language = {
      type: "scraper",
      value: obj.language ?? Languages.TR
    };
  }
}

export class BaseFileDTO {
  organization: string;
  userId: string;
  requestedFileName: string;
  isOrganization: boolean;
}

export class BaseWebScrapingDTO {
  spiderOrParser: boolean;
}

export class PDFFileDTO extends BaseFileDTO {
  makeOcrForTables: boolean;
  saveTablesAsImages: boolean;
  makeOcrForImages: boolean;
}

export class ExcelFileDTO extends BaseFileDTO {
  sheets: Array<ExcelParsingSheetDTO> = [];
}

export class OrganizationFileDTO extends BaseFileDTO {
  organizationSheetName: string;
  columnMappings: FormGroup;
  divisionType: DivisionType;
  divisionColumns: Array<OrganizationDivisionColumnDTO> = [];

  constructor(private fb: FormBuilder) {
    super()
    this.columnMappings = this.fb.group({});
  }
}

export class DocxFileDTO extends BaseFileDTO {
  // Herhangi bir veri taşımasına gerek yok.
}

export class MultimediaFileDTO extends BaseFileDTO {
  hasTranscript: boolean;
  includeImportantMoments: boolean;
}

export class TextMdFileDTO extends BaseFileDTO {
  // Herhangi bir veri taşımasına gerek yok.
}

export class WebScrapingDTO extends BaseWebScrapingDTO {
  // TODO : Crawler içerisindeki işlemler tamamladığında implement edilecek.
}

export class WebCrawlerDTO extends BaseWebScrapingDTO {
  // TODO : Crawler içerisindeki işlemler tamamladığında implement edilecek.
}

class ExcelParsingSheetDTO {
  sheetTitleExists: boolean;
  updateSheetTitles: boolean;
  sheetIndex: number;
  sheetHeaders: Array<ExcelParsingSheetHeadersDTO> = [];
}

class ExcelParsingSheetHeadersDTO {
  key: string;
  type: string;
}

class OrganizationDivisionColumnDTO {
  existingFieldName: string;
  divisionOrder: number;
}

export enum DivisionType {
  COLUMN = "COLUMN",
  PARENT_CHILD = "PARENT_CHILD",
}

export enum AcceptedFileType {
  DOCUMENT = "document",
  SCRAPER = "scraper",
  MULTIMEDIA = "multimedia",
  TABLE = "table",
  ORGANIZATION = "organization",
  QA = "qa",
  API = "api",
  URL = "url",
}

export enum ExtractionMode {
  JUSTEXT = "JUSTEXT",
  TRAFILATURA = "TRAFILATURA",
  AUTO = "AUTO",
}

export enum Languages {
  EN = "EN",
  TR = "TR"
}

export enum FilterTypes {
  STRING = "str",
  DATE = "date",
  INTEGER = "int",
  ENUM = "enum",
}

export enum FileSortField {
  ID = "ID",
  STATUS = "STATUS",
  CREATED_DATE = "CREATED_DATE",
  UPDATED_DATE = "UPDATED_DATE"
}

export enum SortType {
  ASC = "ASC",
  DESC = "DESC"
}

export enum FileStatus {
  ALL = "ALL",
  PENDING = "PENDING",
  // PROCESSING = "PROCESSING",
  FAILED = "FAILED",
  FINISHED = "FINISHED"
}
